import GenericService from "@/shareds/GenericService"
import type { CertificadoInput } from '../../common/types/certificado/CertificadoInput'
import { CertificadoDetalhado } from '../../common/types/certificado/Certificado'
import { Pagina, Paginacao } from "common/types/paginacao"

export const PATH_CERTIFICADO = '/certificados'

class CertificadoService extends GenericService<
  CertificadoDetalhado,
  Omit<CertificadoDetalhado, '_id'>,
  CertificadoInput
> {
  constructor() {
    super(PATH_CERTIFICADO)
  }
  
      async find(_params?: never): Promise<never> {
          throw new Error('Endpoint usa dados paginados, favor utilizar `findPage`')
      }
  
      async findPage(params?: { idIrmao: string } & Partial<Paginacao>) {
      const result = await this.axios.get<Pagina<CertificadoDetalhado>>(this.route, {
        params,
      })
      return result.data
      }
}

export default new CertificadoService()
